import { Component, Input, OnInit } from '@angular/core'
import { DocumentModel } from '../../../../models/document.model'
import { MatTableDataSource } from '@angular/material'
import { LyantheInvoiceLineModel } from '../../../../models/lyanthe/lyanthe.invoice.line.model'
import { LyantheJournalentryModel } from '../../../../models/lyanthe/lyanthe.journalentry.model'
import { Router } from '@angular/router'
import { AdministrationModel } from '../../../../models/administration.model'

@Component({
  selector: 'app-document-details-form',
  templateUrl: './document-details-form.component.html',
  styleUrls: ['./document-details-form.component.scss'],
})
export class DocumentDetailsFormComponent implements OnInit {
  @Input() document: DocumentModel
  @Input() administration: AdministrationModel
  invoiceColumns = ['description', 'ledger', 'amountExcl', 'VATPerc']
  ledgerColumns = ['description', 'ledgerCode', 'vatCode', 'amount', 'debit_credit']

  ledgerTable: any
  invoiceTable: any

  constructor(private _router: Router) {}

  ngOnInit() {
    this.administration = this.document.administration

    this.invoiceTable = new MatTableDataSource<LyantheInvoiceLineModel>(this.document.lyantheInvoice.invoiceLines)
    this.ledgerTable = new MatTableDataSource<LyantheJournalentryModel>(this.document.lyantheInvoice.journalEnties)
  }

  navigateToAdministration() {
    this._router.navigate(['/administrations/' + this.administration.id])
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/documents/document-details/document-details-form/document-details-form.component.ts